import React, { useMemo } from "react";
import classes from "./TopHeader.module.css";
import { BsTruck } from "react-icons/bs";
import { IoIosCall } from "react-icons/io";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Shimmer from "../../../../components/Shimmer";
import classNames from "classnames";

const TopHeader = React.memo(() => {
  const { ConfigData } = useSelector((state) => state.homePageSlice);

  const contactInfo = useMemo(() => {
    if (ConfigData?.support_phone || ConfigData?.footer_text) {
      return (
        <span className={classNames(classes.value, "")}>
          <span className={classes.value}>
            <IoIosCall size={20} />
            <a href={`tel:+${ConfigData?.support_phone}`}>
              {ConfigData?.support_phone}{" "}
            </a>
          </span>
          <span className={classes.supportText}>{ConfigData?.footer_text}</span>
        </span>
      );
    }
    return <Shimmer width={10.4} />;
  }, [ConfigData]);

  return (
    <div className={classes.topheader}>
      <div className="container">
        <div
          className={classes.row}
          style={{
            justifyContent: `${
              ConfigData?.site_header_text ? "space-between" : "flex-end"
            }`,
          }}
        >
          <div
            className={`${
              ConfigData?.site_header_text ? "col-3 col-md-3 col-lg-3" : ""
            }`}
          >
            <span className={classes.value}>
              <BsTruck size={20} />
              <Link to="/track-order">Track Order</Link>
            </span>
          </div>
          {ConfigData?.site_header_text ? (
            <div
              className={classNames(
                "col-lg-6 col-md-6 text-center d-none d-md-block",
                classes.marqueeContainer
              )}
            >
              <div className={classes.marquee}>
                {ConfigData?.site_header_text}
              </div>
            </div>
          ) : null}
          {!ConfigData?.site_header_text && (
            <span className={classes.separator}></span>
          )}
          {contactInfo}
        </div>
        {ConfigData?.site_header_text ? (
          <div
            className={classNames(
              "text-center d-block d-md-none",
              classes.marqueeContainer
            )}
          >
            <div className={classes.marquee}>
              {ConfigData?.site_header_text}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
});

export default TopHeader;
